function Footer() {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} Tomaz Silva Sampaio. Todos os direitos reservados.</p>
    </footer>
  );
}
export default Footer;